function IconSimpleFlag({ fill, stroke }) {
  return (
    <svg width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 3L5.68377 1.43874C6.3313 1.2229 7 1.70487 7 2.38743V3L13 1V9L8.31623 10.5613C7.6687 10.7771 7 10.2951 7 9.61257V9L1 11V3Z" fill={fill} />
      <path fillRule="evenodd" clipRule="evenodd" d="M13.5 0.306274V9.36037L8.47434 11.0356C7.52869 11.3508 6.55294 10.6738 6.50208 9.69301L1.5 11.3604V17H0.5V2.63961L5.52566 0.964388C6.47131 0.64917 7.44706 1.32613 7.49792 2.30697L13.5 0.306274ZM7.5 3.36037V9.61256C7.5 9.95384 7.83435 10.1948 8.15811 10.0869L12.5 8.63961V1.6937L7.5 3.36037ZM1.5 10.3063L6.5 8.63961V2.38741C6.5 2.04613 6.16565 1.80515 5.84189 1.91307L1.5 3.36037V10.3063Z" fill={stroke} />
    </svg>
  )
}

export default IconSimpleFlag